// 응답 시간 측정 장치 (2026-10-08 대표 증상 "누를 때마다 느리다" 확인용)
//  - 각 동작의 "누름 → 서버 응답" ms 를 console.info('[측정] …') 로 남기고, 묶음(reception | doctorCall)별 최근 20회를 보관
//  - window.__dcTiming = { reception: { samples:[…], median }, doctorCall: {…} } — F12 없이 설정 › 원장 호출 하단에도 중앙값 표시
//  - 저장은 이 탭 메모리뿐(새로고침 시 초기화). 환자 이름·내용은 기록하지 않는다(동작 이름과 ms 만)
const KEEP = 20;

function store() {
    if (typeof window === 'undefined') return {};
    if (!window.__dcTiming || typeof window.__dcTiming !== 'object') window.__dcTiming = {};
    return window.__dcTiming;
}

function median(arr) {
    if (!arr.length) return null;
    const s = [...arr].sort((a, b) => a - b);
    const m = Math.floor(s.length / 2);
    return s.length % 2 ? s[m] : Math.round((s[m - 1] + s[m]) / 2);
}

// group: 'reception' | 'doctorCall', label: 동작 이름(예: '호출', '응답'), ms: 걸린 시간, ok: 성공 여부
export function recordTiming(group, label, ms, ok = true) {
    const v = Math.round(Number(ms));
    if (!Number.isFinite(v) || v < 0) return;
    console.info(`[측정] ${group === 'reception' ? '접수' : '원장 호출'} · ${label}${ok ? '' : '(실패)'}`, v, 'ms');
    const st = store();
    const g = st[group] || { samples: [], median: null };
    g.samples = [...g.samples, v].slice(-KEEP);
    g.median = median(g.samples);
    st[group] = g;
}

// 비동기 동작을 감싸 시간을 잰다 — 결과·예외는 그대로 돌려준다
export async function timed(group, label, fn) {
    const t0 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
    try {
        const r = await fn();
        recordTiming(group, label, (typeof performance !== 'undefined' ? performance.now() : Date.now()) - t0, true);
        return r;
    } catch (e) {
        recordTiming(group, label, (typeof performance !== 'undefined' ? performance.now() : Date.now()) - t0, false);
        throw e;
    }
}

export function getTimingMedian(group) {
    const g = store()[group];
    return g ? { median: g.median, count: g.samples.length } : { median: null, count: 0 };
}
